import React, { Component } from 'react';
import { Table, DatePicker, Button, Dropdown, Select, message, Input  } from 'antd';
import { connect } from 'react-redux';
import _ from 'lodash';
import { logout, getAllUsers, downloadreferralDetail, downloadUserData, getReferralData, updateReferralData } from '../../user/action/user.actions'
import Header from "../../../layout/DefaultLayout/Header";
import '../../user/component/providerDeshbord.scss'
import { history } from '../../../helpers'
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import TableComponent from '../../user/component/dummyTable';
import moment from 'moment';
import SideNav from '../../../layout/DefaultLayout/SideNav';

const { Option } = Select;

export class Referrals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usersColumns: [
        {
          title: 'Referral Code',
          dataIndex: 'referral_code',
          key: 'referral_code',
          sorter: true
        },
        {
          title: 'Referred Phone',
          dataIndex: 'referred_phone',
          key: 'referred_phone',
          sorter: true
        },
        {
          title: 'Referred Date',
          dataIndex: 'referred_date',
          key: 'referred_date',
          sorter: true
        },
        {
          title: 'Redeemed Date',
          dataIndex: 'realized_date',
          key: 'realized_date',
          sorter: true
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          sorter: true
        },
        {
          title: 'Claimed',
          dataIndex: 'claimed',
          key: 'claimed',
          sorter: true,
          render: (docName, record, index) => (
            <div>
              <Select
                placeholder="Choose Status"
                value={record.claimed}
                onChange={(e) => { this.handleStatusChange(e, record.id) }}
            >
                <Option value="Claimed">Claimed</Option>
                <Option value="Pending">Pending</Option>
                <Option value="Rejected">Rejected</Option>
            </Select>
            </div>
          ),
        },
        {
            title: 'Remark',
            dataIndex: 'remark',
            key: 'remark',
            sorter: true,
            render: (docName, record, index) => (
                <div>
                  <input className="remark-input" value={record.remark} onChange={(e) => this.handleRemarkChange(e, record.id)} />
                </div>
              ),
        },
        {
          title: 'Created At',
          dataIndex: 'created_at',
          key: 'created_at',
          sorter: true
        },
        {
            title: 'Actions',
            dataIndex: 'id',
            key: 'id',
            render: (docName, record, index) => (
                <div>
                  <div>
                    <Button type="primary" onClick={() => { this.saveData(record) }}>{"Save"}</Button>
                  </div>
                </div>
              ),
          }
      ],
      referral_data: [],
      filter_referral_data: [],
      start_date: '',
      end_date: '',
      sortOrder: null,
      sortedColumn: null,
      remarks: '',
      status: ''
    }
    this.logout = this.logout.bind(this);

  }
  componentDidMount() {
    this.getReferralData();
  }

  saveData = (selectedRecord) => {
    const { dispatch } = this.props;
    let claimedType = selectedRecord.claimed == 'Pending' ? 'P' : selectedRecord.claimed == 'Rejected' ? 'R' : 'C'
    const params = {
      id: selectedRecord.id,
      claimed: claimedType,
      remark: selectedRecord.remark
    }
    dispatch(updateReferralData(params)).then((response) => {
      message.success("Data updated successfully.")
    })
  }

   handleRemarkChange = (e, id) => {
    const editRemarks = { ...this.state.referral_data };
    _.forEach(editRemarks, function(remark){
      if(remark.id == id){
        remark.remark = e.target.value
      }
    })
    this.setState({remarks: editRemarks})
  }

  handleStatusChange = (e, id) => {
    const editStatus = { ...this.state.referral_data };
    _.forEach(editStatus, function(remark){
      if(remark.id == id){
        remark.claimed = e
      }
    })
    this.setState({status: editStatus})
  }

  logout(e) {
    const { dispatch } = this.props;
    dispatch(logout())
  }

  getReferralData = () => {
    const { dispatch } = this.props;
    dispatch(getReferralData()).then((response) => {
      let data = this.initializeDate(response.data)
      let sortedData = _.sortBy(data, 'referred_date').reverse();
      this.setState({ referral_data: sortedData, filter_referral_data: sortedData})
    })
  }

  initializeDate = (data) => {
    _.map(data, function (record) {
      record['created_at'] = new Date(record['created_at']).toLocaleString()
    })
    return data
  }

  downloadReport = () => {
    const { dispatch } = this.props;
    if(this.state.start_date && this.state.end_date){
      var startDateFormat = new Date(this.state.start_date)
      var startDate = `${startDateFormat.getFullYear()}-${startDateFormat.getMonth() + 1}-${startDateFormat.getDate()}`
      var endDateFormat = new Date(this.state.end_date)
      var endDate = `${endDateFormat.getFullYear()}-${endDateFormat.getMonth() + 1}-${endDateFormat.getDate()}`
      var data = {
        start_date: startDate,
        end_date: endDate
      }
      dispatch(downloadreferralDetail(data)).then((response) => {
        let data = this.initializeDate(response.data)
        var dataDownload = data
        var fileName = "Reports"
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(dataDownload);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const dataDetail = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(dataDetail, fileName + fileExtension);
      })
    }else{
      message.error("Please select start date and end date to download the reports")
    }
  }

  filterUserData = () => {
    if(this.state.start_date && this.state.end_date){
      let editData = [...this.state.referral_data]
      var startDateFormat = new Date(this.state.start_date)
      var endDateFormat = new Date(this.state.end_date)
      editData = _.filter(editData, function (o) { return moment(o['created_at']).isBetween(startDateFormat, endDateFormat) });
      this.setState({ filter_referral_data: editData });
    }else{
      this.setState({ filter_referral_data: this.state.referral_data });
    }
    
  }

  handleDateChange = (name, value) => {
    if (name == 'start_date') {
      this.setState({ 'start_date': value });
    } else {
      this.setState({ 'end_date': value });
    }
  }

  handleSearch = (value) => {
    let updatedUserData = [...this.state.referral_data];
    if (value !== "") {
      updatedUserData = updatedUserData.filter((item) =>
      Object.values(item).some((val) =>
        val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    )
    }
    this.setState({filter_referral_data: updatedUserData})
  }

 handleSort = (column) => {
  let editResolutionData = [...this.state.referral_data]
  let order = this.state.sortOrder
  let currentColumn = this.state.sortedColumn
  if (column === currentColumn) {
    // setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    order = order == 'asc' ? 'desc' : 'asc'
  } else {
    currentColumn = column;
    order = 'asc'
    // setSortedColumn(column);
    // setSortOrder('asc');
  }
  editResolutionData = _.orderBy(editResolutionData, [currentColumn], [order])
  this.setState({referral_data: editResolutionData, sortOrder: order, sortedColumn: currentColumn});
};

render() {
  const { usersColumns, data, referral_data } = this.state
  return (
    <div>
      <Header></Header>
      {/* <SideNav/> */}
      <div className="services-background">
        <div className="biddings-container">
          <div className="service-heading-txt">Referrals</div>
          <div className="row">
            <div className="col-4">
              <DatePicker
                className='experience-date-picker-box'
                placeholder="Start Date"
                required
                name="start_date"
                value={this.state.start_date}
                onChange={(e) => { this.handleDateChange('start_date', e) }}
              />
            </div>
            <div className="col-4">
              <DatePicker
                className='experience-date-picker-box'
                placeholder="End Date"
                name="end_date"
                value={this.state.end_date}
                onChange={(e) => { this.handleDateChange('end_date', e) }}
              />
            </div>
            <div className="col-4">
              <Button className='btn-added-right' onClick={() => { this.downloadReport() }}>
                Download Report
              </Button>
              <Button className='btn-added-right' onClick={() => { this.filterUserData() }}>
                View Data
              </Button>
            </div>
          </div>
          <Input placeholder="Search Referral" style={{ width: '300px', marginBottom: '20px' }} onChange={(e) => this.handleSearch(e.target.value)} />
          <Table
            columns={usersColumns}
            dataSource={this.state.filter_referral_data}
            onChange={(pagination, filters, sorter) => {
              this.handleSort(sorter.field);
            }}
            sortDirections={['ascend', 'descend']}
            sortOrder={this.state.sortOrder}
            pagination={false}
          />
        </div>
      </div>
    </div >
  );
}
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  }
}

export default connect(mapStateToProps)(Referrals);
